import React, { useState } from "react"

interface TrafficAllowedProps {
    editMode: boolean
    isEditable: boolean
    trafficAllowed: string[]
    handleChange: (value: string[]) => void
    options: string[]
}

const TrafficAllowedSection: React.FC<TrafficAllowedProps> = ({
    editMode,
    isEditable,
    trafficAllowed,
    handleChange,
    options,
}) => {
    const [showAllowedOnly, setShowAllowedOnly] = useState(true)

    const visibleOptions = showAllowedOnly
        ? options.filter((option) => trafficAllowed.includes(option))
        : options

    return (
        <div className="w-full rounded-xl p-4 flex flex-col min-h-[200px]">
            {/* content area */}
            <div className="flex flex-wrap gap-3 justify-start">
                {visibleOptions.map((option) => {
                    const checked = trafficAllowed.includes(option)

                    if (editMode && isEditable) {
                        return (
                            <button
                                key={option}
                                type="button"
                                onClick={() => {
                                    const updated = checked
                                        ? trafficAllowed.filter((t) => t !== option)
                                        : [...trafficAllowed, option]
                                    handleChange(updated)
                                }}
                                className={`px-3 py-1.5 rounded-md border text-sm transition ${checked
                                    ? "bg-orange-500 text-white border-orange-500"
                                    : "border-gray-300 text-gray-600 hover:border-orange-400"
                                    }`}
                            >
                                {option}
                            </button>
                        )
                    }

                    return (
                        <div
                            key={option}
                            className={`px-3 py-1.5 rounded-md border text-sm ${checked
                                ? "bg-orange-500 text-white border-orange-500"
                                : "border-gray-300 text-gray-400"
                                }`}
                        >
                            {option}
                        </div>
                    )
                })}
            </div>

            {/* button pinned bottom-right via flexbox */}
            <div className="flex justify-end mt-6">
                <button
                    className={`px-4 py-1.5 text-sm rounded-full transition border shadow-sm ${showAllowedOnly
                        ? "bg-orange-100 text-orange-600 border-orange-300 hover:bg-orange-200"
                        : "bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    onClick={() => setShowAllowedOnly((prev) => !prev)}
                >
                    {showAllowedOnly ? "Show All" : "Show Allowed"}
                </button>
            </div>
        </div>
    )
}

export default TrafficAllowedSection
